// import { Timestamp } from '@/firebase.js'
import { weekdays } from '@/const.js'
import { DateTime } from 'luxon'
import { getLocalDateTime, getStoreTimezone } from '@/utils.js'

const getDefaultState = () => {
  return {
    now: null,
    minute: null,
    hour: null,
    weekDay: null,
    monthDay: null,
    timeString: null,
    timezone: null,
    hasUpdatedToday: true
  }
}

const state = getDefaultState()

const getters = {
  now: state => state.now,
  minute: state => state.minute,
  hour: state => state.hour,
  weekDay: state => state.weekDay,
  monthDay: state => state.monthDay,
  timezone: state => state.timezone,
  locationTime: state => state.timeString,
  hasUpdatedToday: state => state.hasUpdatedToday,
  weekDayName: state => {
    try {
      return weekdays[state.weekDay]
    } catch {
      return null
    }
  },
  dateTime: () => DateTime,
  // Helper method to get a DateTime with the correct timezone
  getDateTime: () => (date = null) => getLocalDateTime(date)
}

const actions = {
  updateTime({ rootGetters, commit, dispatch }) {
    // Use our utility function to get current time in the store's timezone
    const nowDateTime = getLocalDateTime()
    const timezone = getStoreTimezone()
    
    dispatch('setMinute', nowDateTime.minute)
    dispatch('setHour', nowDateTime.hour)
    dispatch('setWeekDay', nowDateTime.weekday % 7) // 0-6
    dispatch('setMonthDay', nowDateTime.day)
    commit('setNow', nowDateTime)
    commit('setTimezone', timezone)
    commit('updateTimeString')

    setTimeout(() => {
      dispatch('updateTime')
    }, 1000 * 60 * 1) // Update every minute
  },

  setMinute({ state, commit }, minute) {
    if (state.minute !== minute) commit('setMinute', minute)
  },
  setHour({ state, commit }, hour) {
    if (state.hour !== hour) commit('setHour', hour)
  },
  setWeekDay({ state, commit }, weekDay) {
    if (state.weekDay !== weekDay) {
      commit('setWeekDay', weekDay)
      if (state.hasUpdatedToday == false) window.location.reload()
      // hasUpdatedToday resets to True after reload
      commit('setHasUpdatedToday', false)
    }
  },
  setMonthDay({ state, commit }, monthDay) {
    if (state.monthDay !== monthDay) commit('setMonthDay', monthDay)
  },
  setHasUpdatedToday({ commit }, bool) {
    commit('setHasUpdatedToday', bool)
  },
  async resetTimeState({ commit }) {
    await commit('resetState', null)
  }
}

const mutations = {
  setNow(state, now) {
    this._vm.$set(state, 'now', now)
  },
  setMinute(state, minute) {
    this._vm.$set(state, 'minute', minute)
  },
  setHour(state, hour) {
    this._vm.$set(state, 'hour', hour)
  },
  setTimezone(state, timezone) {
    this._vm.$set(state, 'timezone', timezone)
  },
  updateTimeString(state) {
    let hours = state.hour % 12 == 0 ? 12 : state.hour % 12
    let minutes = state.minute < 10 ? '0' + state.minute : state.minute
    let period = state.hour > 11 ? 'p' : 'a'
    this._vm.$set(state, 'timeString', `${hours}:${minutes}${period}`)
  },
  setTimeString(state, time) {
    this._vm.$set(state, 'timeString', time)
  },
  setWeekDay(state, day) {
    this._vm.$set(state, 'weekDay', day)
  },
  setMonthDay(state, day) {
    this._vm.$set(state, 'monthDay', day)
  },
  setHasUpdatedToday(state, bool) {
    this._vm.$set(state, 'hasUpdatedToday', bool)
  },
  resetState(state) {
    const defaultState = getDefaultState()
    Object.keys(defaultState).forEach(key => {
      state[key] = defaultState[key]
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

// // ET timezone offset in hours.
// var timezone = -4
// // Timezone offset in minutes + the desired offset in minutes, converted to ms.
// // This offset should be the same for ALL date calculations, so you should only need to calculate it once.
// var offset = (mydate.getTimezoneOffset() + timezone * 60) * 60 * 1000

// // Use the timestamp and offset as necessary to calculate min/sec etc, i.e. for countdowns.
// var timestamp = mydate.getTime() + offset,
//   seconds = Math.floor(timestamp / 1000) % 60,
//   minutes = Math.floor(timestamp / 1000 / 60) % 60,
//   hours = Math.floor(timestamp / 1000 / 60 / 60)

// // Or update the timestamp to reflect the timezone offset.
// mydate.setTime(mydate.getTime() + offset)
// // Then Output dates and times using the normal methods.
// var date = mydate.getDate(),
//   hour = mydate.getHours()
